import React from 'react';
import { Controls } from 'shared/helper/form';
import { T } from 'shared/helper/translate';
import { price } from 'researcher/helpers/price';
var Radio = Controls.Radio;
var Credits = function Credits(_ref) {
  var currency = _ref.currency,
    maxAppliableCredits = _ref.maxAppliableCredits,
    updateCreditsApplied = _ref.updateCreditsApplied,
    creditsAvailable = _ref.creditsAvailable;
  var adjustCreditsApplied = function adjustCreditsApplied(value) {
    return updateCreditsApplied(value === 'yes' ? maxAppliableCredits : 0);
  };
  return /*#__PURE__*/React.createElement("div", {
    className: "mb-3"
  }, /*#__PURE__*/React.createElement(T.md, {
    source: "You have **%(amount)s** in credits available.",
    params: {
      amount: price(currency, creditsAvailable, true, true)
    }
  }), /*#__PURE__*/React.createElement(Radio, {
    name: "useCredits",
    styles: {
      wrapper: 'mb-3'
    },
    onChange: adjustCreditsApplied,
    options: [{
      value: 'yes',
      label: /*#__PURE__*/React.createElement(T.md, {
        inline: true,
        source: "Apply **%(amount)s** credits to this order",
        params: {
          amount: price(currency, maxAppliableCredits, true, true)
        }
      })
    }, {
      value: 'no',
      label: /*#__PURE__*/React.createElement(T, {
        source: "Do not use credits to pay for this order"
      })
    }]
  }));
};
export default Credits;